<div class="header-row" *ngIf="isDefaultHeaderMode;else simpleHeader">
    <div class="app-logo">
        <img src="assets/images/csadminlogo.gif" alt="csadminlogo" (click)="goToHome()">
    </div>
    <div class="bg-graphics">
        <img src="assets/images/GUIbg.gif" alt="header-bg">
    </div>
    <div>
        <div class="inactive-lookup" *ngIf="!user.isAuthenticated">
            <img src="assets/images/inactive_top.png" alt="Inactive Lookup">
        </div>
        <div class="rounded-1 header-link" *ngIf="user.isAuthenticated" [ngClass]="{'mar-L210': !([ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.REPRESENTATIVE] | accessManagement: 'ANY' )}">
            <ng-container *ngIf="([ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.REPRESENTATIVE] | accessManagement: 'ANY' )" >
                <a class="header-link-text-lookup" href="javascript:void(0);" (click)="redirectBenefitLookup()">
                    {{content.labels.benefit_lookup}}
                </a> |
            </ng-container>
            <a class="header-link-text member-payment" href="javascript:void(0);" (click)="memberPaymentResearchSso()">
                {{content.labels.member_payment_research}}
            </a> |
            <a class="header-link-text" href="javascript:void(0);" (click)="goToProfile();">
                {{content.labels.my_profile}}
            </a> |
            <a class="header-link-text" href="javascript:void(0);" (click)="logOff();">
                {{content.labels.logoff}}
            </a>
        </div>
        <div class="bls-logo">
            <img src="assets/images/BLlogo.gif" alt="Blue Shield of California">
        </div>
    </div>
</div>
<ng-template #simpleHeader>
    <div class="simple-header">
        <img class="secondary-logo" src="assets/images/bsc-logosecondary.gif" alt="Bsc secondary logo">
        <button class="home-btn" (click)="goToHome()">Home</button>
    </div>
</ng-template>